import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import {
  LICENSE_REQUIRED_ROUTE,
  readLicenseError,
} from 'src/app/core/errors/license-error';

/**
 * Manda o usuário para a tela de licença quando o backend responde que o plano não contempla o
 * Ritmos.
 *
 * A guarda de disparo único não é detalhe: sem a licença raiz TODA requisição do carregamento
 * inicial volta 403, e cada uma delas pediria uma navegação. É o mesmo problema — e a mesma
 * solução — do `isRedirectingToLogin` no `auth-error.interceptor`. O flag zera sozinho no próximo
 * carregamento da página, que é exatamente quando faz sentido tentar de novo: se a licença foi
 * regularizada, o backend para de recusar.
 */
let isRedirectingToLicensePage = false;

/** Uso exclusivo de testes: reinicia o guard entre casos. */
export function resetLicenseRedirectGuardForTests(): void {
  isRedirectingToLicensePage = false;
}

export const licenseInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (readLicenseError(err) !== 'package') {
        return throwError(() => err);
      }

      if (!isRedirectingToLicensePage && router.url !== LICENSE_REQUIRED_ROUTE) {
        isRedirectingToLicensePage = true;
        void router.navigateByUrl(LICENSE_REQUIRED_ROUTE);
      }

      return throwError(() => err);
    }),
  );
};
